import axios from 'axios'

declare interface ApiViolation {
  code: string,
  message: string,
  propertyPath: string,
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorHandler(error: any): Promise<any> {
  if (!error.response?.data?.violations && error.response?.data?.detail) {
    const message = `${error.response.data.detail}`
    return Promise.reject(new Error(message))
  }

  return Promise.reject(error)
}

export function getErrorMessage(error: unknown) {
  if (axios.isAxiosError(error)) {
    if (error.response?.data?.violations) {
      return error.response.data.violations.map((violation: ApiViolation) => violation.message).join(' ')
    }

    return error.response?.data?.message
      || error.response?.data?.detail
      || error.message
  }

  if (error instanceof Error || error instanceof TypeError) {
    return error.message
  }

  if (error instanceof Object) {
    return error.toString()
  }

  return 'Something went wrong.'
}
